import React from "react";
import "../Stepmintmobile/css/stepmintmobile.css";

import { Container, Row, Col } from "react-bootstrap";
import { Zoom } from "react-reveal";
import "../Stepmintmobile/css/mobilefooter.css";

const Stepmint = () => {
  return (
    <>
      <div className="position-relative">
        <div className="sm-cp1"></div>
        <div className="sm-cp2"></div>
        <div className="sm-cp3"></div>
        <div className="sm-cp4"></div>
        <div className="sm-cp5"></div>
        <section className=" text-white  py-5">
          <Container>
            <div className="d-flex flex-column align-items-center">
              <img src="assets\images\mobile01.png" alt="" />
              <h2 style={{ color: "#53CFD2", fontWeight: 700 }}>
                How Stepmint Works
              </h2>
              <p className="sm-p">
                StepMint offers a straightforward way to participate in the NFT
                space and  generate steprewards. Here's a breakdown of how it
                works:
              </p>
            </div>
            <br />
            <br />
            <div>
              <h3 className="mb-2 sm-h" style={{ color: "#53CFD2", fontWeight: 700 }}>
                NFT Holding
              </h3>
              <br />
              <Row>
                <Col lg={7} className="">
                  <div className="mobile-subscription px-3">
                    <ul className="mb-0 py-4 ">
                      <li>
                        NFT Box Holding : Get NFT Boxes at your convenience.
                      </li>
                      <li>
                        Minimum Holding : The minimum required holding is 100 Tier NFTs.
                      </li>
                      <li>
                        NFT Enhancement : You can get an NFT of any value above 100 Tier, provided it's in multiples of 100 (e.g., 300, 800, 1200).
                      </li>
                      <li>
                        NFT Range : Ranging from 100 Tier NFTs to an infinite value, allowing flexibility for all members.
                      </li>
                      <li>
                        Reward Token :  You'll receive rewards in Mr Mint Tokens.
                      </li>
                    </ul>
                  </div>
                </Col>
                <Col
                  lg={5}
                  className="d-flex place-item-center justify-content-center"
                >
                  <img
                    className=" img-fluid"
                    src="assets/images/nftbox1.svg "
                    alt=""
                    style={{ minWidth: 240 }}
                  />
                </Col>
              </Row>
            </div>

            <br />
            <br />
            <div>
              <h3 style={{ color: "#53CFD2", fontWeight: 700 }}>STEP REWARDS</h3>
              <p>Your rewards depend on your total NFT holdings.</p>

              <Row className="gy-3">
                <Col>
                  <div className="step-card-2 p-4">
                    <p className="step-card">Silver Sprint</p>
                    <hr />
                    <Row>
                      <Col>
                        <p className="step-detail mb-0">NFT Tier</p>
                      </Col>
                      <Col>
                        <p className="step-detail mb-0 text-end">100 - 900</p>
                      </Col>
                    </Row>
                    <hr />
                    <Row>
                      <Col>
                        <p className="step-detail mb-0">% Reward</p>
                      </Col>
                      <Col>
                        <p className="step-detail mb-0 text-end">0.5%</p>
                      </Col>
                    </Row>
                    <div className="nft-detail-block  mt-4 px-2">
                      <Row className="gy-2 p-2">
                        <Col
                          lg={12}
                          className="d-flex justify-content-between align-items-center"
                        >
                          <div>
                            <h6
                              className="mb-1"
                              style={{ fontWeight: 700, color: "#00FF26" }}
                            >
                              Booster %
                            </h6>
                            <small style={{ fontSize: 12 }}>
                              Reward After 1st Referral
                            </small>
                          </div>
                          <div className="text-end">
                            <h5>0.55%</h5>
                            <small style={{ fontSize: 12 }}>
                              On Same or Above
                            </small>
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <div className="nft-detail-block  mt-3 px-2">
                      <Row className="gy-2 p-2">
                        <Col
                          lg={12}
                          className="d-flex justify-content-between align-items-center"
                        >
                          <div>
                            <h6
                              className="mb-1"
                              style={{ fontWeight: 700, color: "#00FF26" }}
                            >
                              Booster %
                            </h6>
                            <small style={{ fontSize: 12 }}>
                              Reward After 2nd Referral
                            </small>
                          </div>
                          <div className="text-end">
                            <h5>0.60%</h5>
                            <small style={{ fontSize: 12 }}>
                              On Same or Above
                            </small>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Col>
                <Col>
                  <div className="step-card-2 p-4">
                    <p className="step-card">Gold Sprint</p>
                    <hr />
                    <Row>
                      <Col>
                        <p className="step-detail mb-0">NFT Tier</p>
                      </Col>
                      <Col>
                        <p className="step-detail mb-0 text-end">1000 - 9000</p>
                      </Col>
                    </Row>
                    <hr />
                    <Row>
                      <Col>
                        <p className="step-detail mb-0">% Reward</p>
                      </Col>
                      <Col>
                        <p className="step-detail mb-0 text-end">0.6%</p>
                      </Col>
                    </Row>
                    <div className="nft-detail-block  mt-4 px-2">
                      <Row className="gy-2 p-2">
                        <Col
                          lg={12}
                          className="d-flex justify-content-between align-items-center"
                        >
                          <div>
                            <h6
                              className="mb-1"
                              style={{ fontWeight: 700, color: "#00FF26" }}
                            >
                              Booster %
                            </h6>
                            <small style={{ fontSize: 12 }}>
                              Reward After 1st Referral
                            </small>
                          </div>
                          <div className="text-end">
                            <h5>0.65%</h5>
                            <small style={{ fontSize: 12 }}>
                              On Same or Above
                            </small>
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <div className="nft-detail-block  mt-3 px-2">
                      <Row className="gy-2 p-2">
                        <Col
                          lg={12}
                          className="d-flex justify-content-between align-items-center"
                        >
                          <div>
                            <h6
                              className="mb-1"
                              style={{ fontWeight: 700, color: "#00FF26" }}
                            >
                              Booster %
                            </h6>
                            <small style={{ fontSize: 12 }}>
                              Reward After 2nd Referral
                            </small>
                          </div>
                          <div className="text-end">
                            <h5>0.70%</h5>
                            <small style={{ fontSize: 12 }}>
                              On Same or Above
                            </small>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Col>
                <Col>
                  <div className="step-card-2 p-4">
                    <p className="step-card">Diamond Sprint</p>
                    <hr />
                    <Row>
                      <Col>
                        <p className="step-detail mb-0">NFT Tier</p>
                      </Col>
                      <Col>
                        <p className="step-detail mb-0 text-end">
                          10,000 - Unlimited
                        </p>
                      </Col>
                    </Row>
                    <hr />
                    <Row>
                      <Col>
                        <p className="step-detail mb-0">% Reward</p>
                      </Col>
                      <Col>
                        <p className="step-detail mb-0 text-end">0.7%</p>
                      </Col>
                    </Row>
                    <div className="nft-detail-block  mt-4 px-2">
                      <Row className="gy-2 p-2">
                        <Col
                          lg={12}
                          className="d-flex justify-content-between align-items-center"
                        >
                          <div>
                            <h6
                              className="mb-1"
                              style={{ fontWeight: 700, color: "#00FF26" }}
                            >
                              Booster %
                            </h6>
                            <small style={{ fontSize: 12 }}>
                              Reward After 1st Referral
                            </small>
                          </div>
                          <div className="text-end">
                            <h5>0.75%</h5>
                            <small style={{ fontSize: 12 }}>
                              On Same or Above
                            </small>
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <div className="nft-detail-block  mt-3 px-2">
                      <Row className="gy-2 p-2">
                        <Col
                          lg={12}
                          className="d-flex justify-content-between align-items-center"
                        >
                          <div>
                            <h6
                              className="mb-1"
                              style={{ fontWeight: 700, color: "#00FF26" }}
                            >
                              Booster %
                            </h6>
                            <small style={{ fontSize: 12 }}>
                              Reward After 2nd Referral
                            </small>
                          </div>
                          <div className="text-end">
                            <h5>0.80%</h5>
                            <small style={{ fontSize: 12 }}>
                              On Same or Above
                            </small>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>

            <br />
            <br />

            <Row className="gy-3">
              <Col lg={6}>
                <div className="step-card-2 p-4">
                  <h3 style={{ color: "white", fontWeight: 700 }}>
                    Step Reward Calculation
                  </h3>
                  <p className="mb-0">
                    For example, a user with 500 Tier NFT earns a 0.50% daily reward, which equals 2.50.
                  </p>
                </div>
              </Col>
              <Col lg={6}>
                <div className="step-card-2 p-4">
                  <h3 style={{ color: "white", fontWeight: 700 }}>
                    NFT Duration
                  </h3>
                  <p className="mb-0">
                    Acquired NFT Tier lasts for one year, i.e., 365 days from the date of NFT acquisition.
                  </p>
                </div>
              </Col>
            </Row>
            <br />
            <Row className="align-items-stretch gy-3">
              <Col lg={6} className="d-flex">
                <div className="step-card-2 p-4 w-100 d-flex flex-column justify-content-start">
                  <h3 style={{ color: "white", fontWeight: 700 }}>
                    Mr Mint Conversion
                  </h3>
                  <p className="mb-0">
                    Your reward is converted into Mr Mint Tokens based on the current Mr Mint market value. For example, if Mr Mint is valued at 0.10, a 2.50 reward would give you 25 Mr Mint Tokens daily.
                  </p>
                </div>
              </Col>

              <Col lg={6} className="d-flex">
                <div className="step-card-2 p-4 w-100 d-flex flex-column justify-content-between">
                  <h3 style={{ color: "white", fontWeight: 700 }}>
                    Staggered NFT Holdings
                  </h3>
                  <p className="mb-0">
                    If you acquire a 500 Tier NFT on April 1st and a 1500 Tier NFT on April 15th, your reward is calculated based on your total NFT Holdings of 2,000. After one year, on April 1st, 2026, the first 500 Tier NFT expires your rewards will be adjusted accordingly.
                  </p>
                </div>
              </Col>
            </Row>

            <br />
            <br />
            <h3 style={{ color: "#53CFD2", fontWeight: 700 }}>
              Referral and Matching Bonuses
            </h3>
            <br />
            <Row>
              <Col lg={6}>
                <div className="step-card-2 h-100  p-4 d-flex flex-column w-100 justify-content-center align-items-center">
                  <img
                    className=" img-fluid"
                    src="assets/images/icon03.png "
                    alt=""
                    style={{ width: 246, height: 238 }}
                  />
                  <h3
                    className="mt-3"
                    style={{ color: "white", fontWeight: 700 }}
                  >
                    Booster Reward Levels
                  </h3>
                  <ul className="mb-0 py-4 ">
                    <li>
                      Referring a user with a 1000 Tier NFT or above increases your reward to 0.65% (instead of 0.60%).
                    </li>
                    <li>
                      Referring two users with 1000 Tier NFT or above increases your reward to 0.70%.
                    </li>
                    <li>
                      Booster Levels: The booster reward applies up to two levels.
                    </li>
                    <li>
                      Vesting Wallet: Booster rewards are credited into your Vesting Wallet.

                    </li>
                  </ul>
                </div>
              </Col>
              <Col lg={6}>
                <div className="w-100 d-flex justify-content-center">
                  <img
                    className=" img-fluid"
                    src="assets/images/icon2.png "
                    alt=""
                    style={{ minWidth: 200 }}
                  />
                </div>
              </Col>
            </Row>
            <br />
            <br />
            <Row className="gy-3">
              <Col lg={6} className="d-flex flex-column gap-3">
                <div className="step-card-2 p-4">
                  <h3 style={{ color: "white", fontWeight: 700 }}>
                    Referral Bonus
                  </h3>
                  <p className="mb-0">
                    Earn a 5% referral bonus when you introduce a new NFT holder to the StepMint community.
                  </p>
                </div>
                <div className="step-card-2 p-4">
                  <h3 style={{ color: "white", fontWeight: 700 }}>
                    Matching Bonus
                  </h3>
                  <p className="mb-0">
                    Receive an 8% matching bonus when your referral acquires any NFT Tier.
                  </p>
                </div>
                <div className="step-card-2 p-4">
                  <h3 style={{ color: "white", fontWeight: 700 }}>
                    Business Wallet
                  </h3>
                  <p className="mb-0">
                    Referral and matching bonuses are deposited into your Business Wallet.
                  </p>
                </div>
              </Col>
              <Col lg={6}>
                <div className="step-card-2 p-4 d-flex flex-column w-100 justify-content-center align-items-center">
                  <img
                    className=" img-fluid"
                    src="assets/images/icon05.svg "
                    alt=""
                    style={{ width: 246, height: 238 }}
                  />
                  <h3
                    style={{ color: "white", fontWeight: 700 }}
                    className="mt-3"
                  >
                    Booster Rewards
                  </h3>
                  <p className="mb-0 text-center">
                    Eligibility: When you hold a 100 Tier NFT or above and refer to another user who also has a 100 Tier NFT or above, you become eligible for a booster reward.
                  </p>
                </div>
              </Col>
            </Row>
            <br />
            <br />
            <Row>
              <Col lg={6}>
                <div className=" p-4 d-flex flex-column w-100 justify-content-center align-items-center">
                  <img
                    className=" img-fluid"
                    src="assets/images/hiw05.png "
                    alt=""
                    style={{ width: 246, height: 238 }}
                  />
                  <h3
                    style={{ color: "white", fontWeight: 700 }}
                    className="mt-3"
                  >
                    Wallets & Withdraws
                  </h3>
                  <p className="mb-0 text-center">
                    There will be 3 separate wallets in our App & Dapp:
                  </p>
                </div>
              </Col>
              <Col lg={6} className="d-flex flex-column gap-3">
                <div className="step-card-2 p-4">
                  <h3 style={{ color: "white", fontWeight: 700 }}>
                    StepMint Wallet
                  </h3>
                  <p className="mb-0">
                    100% of per daily Step Rewards earned through NFT Boxes will be credited to the StepMint Wallet.
                  </p>
                </div>
                <div className="step-card-2 p-4">
                  <h3 style={{ color: "white", fontWeight: 700 }}>
                    Business Wallet
                  </h3>
                  <p className="mb-0">
                    Referral Rewards and Community Rewards will be credited (100%) to the Business Wallet.
                  </p>
                </div>
                <div className="step-card-2 p-4">
                  <h3 style={{ color: "white", fontWeight: 700 }}>
                    Vesting Wallet
                  </h3>
                  <p className="mb-0">
                    Booster Rewards earned per day through Step Rewards will be credited to the Vesting Wallet.
                  </p>
                </div>
              </Col>

            </Row>
            <br />
            <br />
            <div className="mobile-subscription px-3">
              <ul className="mb-0 py-4 ">
                <li>
                  StepMint Wallet withdrawals can be made once every 168 hours with a minimum of 100 MNT and a maximum of 1500 MNT.
                </li>
                <li>
                  Business Wallet withdrawals can be made once every 24 hours with a minimum of 100 MNT and a maximum of 1500 MNT.
                </li>
                <li>
                  The 168-hour and 24-hour withdrawal windows begin at the exact time a StepMint or Business withdrawal request is submitted. Withdrawal requests may take 24 to 48 hours for approval and processing.                </li>
                <li>
                  Funds deposited into the Vesting Wallet will be released exactly 365 days after the date of deposit.
                </li>
                <li>
                  Withdrawals can be initiated from any one wallet once in 24 hours.
                </li>
              </ul>
            </div>
            <br />
            <br />

            <Row>
              <h3 style={{ color: "white", fontWeight: 700, textAlign: 'center' }}>
                Fitness Feature
              </h3>

              <p className="mb-0 text-center">
                Tailored fitness features are designed to support your unique health objectives.
              </p>
              <br />
              <br />
              <Col lg={6}>

                <div className=" p-4 d-flex flex-column w-100 justify-content-center align-items-center">
                  <img
                    className=" img-fluid"
                    src="assets/images/healthProfile.png"
                    alt=""
                    style={{ width: 246, height: 238 }}
                  />
                  {/* <h3>Elevate Your Routine</h3> */}
                  {/* <p className="mb-0 text-center">Explore powerful new tools designed to take your fitness journey to the next level.</p> */}
                </div>
              </Col>
              <Col>
                <div>
                  <div className="mobile-subscription py-4">
                    <h3 style={{ color: "white", fontWeight: 700, textAlign: 'center' }}>
                      Health Profile
                    </h3>
                    <p className="mb-0 text-center">
                      The Health Profile helps personalize your fitness journey by collecting key personal and lifestyle details:
                    </p>
                    <ul className="list-disc ">
                      <li>Basic Info (Gender, DOB, Weight, Height)</li>
                      <li>Fitness Level (Lightly/Very Active)</li>
                      <li>Goal (Lose/Maintain Weight, Gain Muscle)</li>
                      <li>Profession (Student, Professional, Homemaker, etc.)</li>
                    </ul>
                    <p className="mb-0   pl-2">Completing this profile improves tracking accuracy and content personalization.</p>
                  </div>
                </div>
              </Col>
            </Row>
            <br />
            <br />
            <div>
              <h3 style={{ color: "white", fontWeight: 700, textAlign: 'center' }}>
                Reminders
              </h3>
              <p className="text-center">
                Custom Reminders helps users maintain wellness routines with timely push notifications.
              </p>
              <br />
              <div className="mobile-subscription p-4">
                <Row className="gy-3">
                  <Col lg={6}>
                    <h3 style={{ color: "white", fontWeight: 700, textAlign: 'center' }}>Reminder Setup</h3>
                    <ul className="mb-0 py-4">
                      <li>Access: Menu → Reminders → Create New Reminder
                      </li>
                      <li>Create: Tap “+” or “Add Reminder”</li>
                      <li>Edit Anytime: Modify or delete as needed</li>
                      <li>Purpose: Reinforces healthy habits with personalized prompts</li>
                      <li>Note: Custom messages improve relevance and motivation
                      </li>
                    </ul>
                  </Col>
                  <Col lg={6}>
                    <h3 style={{ color: "white", fontWeight: 700, textAlign: 'center' }}>How It Works?
                    </h3>
                    <ul className="mb-0 py-4">
                      <li>Choose Reminder Type</li>
                      <li>Enter Reminder Details</li>
                      <li>Save and Activate</li>
                      <li>Reminder in the form of push notification</li>
                      <li>Managing Reminders
                      </li>
                    </ul>
                  </Col>
                </Row>
              </div>
            </div>
            <br />
            <br />
            <div>
              <h3 style={{ color: "white", fontWeight: 700, textAlign: 'center' }}>
                BMI BMR
              </h3>
              <p className="text-center">
                Based on profile data, this module helps users understand their body composition and caloric needs. It calculates BMI, BMR, and TDEE                </p>
              <br />
              <div className="mobile-subscription p-4">
                <Row className="gy-3">
                  <Col lg={6}>
                    <h3 style={{ color: "white", fontWeight: 700, textAlign: 'center' }}>Health Data Access</h3>
                    <ul className="mb-0 py-4">
                      <li>The app securely accesses your age, height, weight, and gender from your Health Profile.
                      </li>

                    </ul>
                    <h3 style={{ color: "white", fontWeight: 700, textAlign: 'center' }}>Auto Calculation</h3>
                    <ul className="mb-0 py-4">
                      <li>Based on the retrieved data:BMI is calculated using your height and weight.

                      </li>
                      <li>BMR is calculated using the Mifflin-St. Jeor equation (using age, gender, height, and weight).


                      </li>
                    </ul>
                    <h3 style={{ color: "white", fontWeight: 700, textAlign: 'center' }}>Real-Time Display</h3>
                    <ul className="mb-0 py-4">
                      <li>Your BMI and BMR stats are displayed directly in the app — no need to enter anything manually.

                      </li>

                    </ul>
                    <h3 style={{ color: "white", fontWeight: 700, textAlign: 'center' }}>Stay Informed</h3>
                    <ul className="mb-0 py-4">
                      <li>Easily track where you stand — underweight, normal, overweight — with color-coded indicators based on your BMI category.
                      </li>

                    </ul>
                  </Col>
                </Row>
              </div>
            </div>
          </Container>
        </section>
      </div>
    </>
  );
};
export default Stepmint;
